import DataResource from '../../../common/v4/DataResource'
import Panel from '../../../common/layout/Panel'
import CallLogDetails from './details'
import Tabs from '../../../common/Tabs'
import { aiTabs } from '../shared/aiTabs';

const AiCallLogs = (props) => {
    const today = new Date();
    const data = {
        url: '/admin/ai/call_logs',
        data: {
            data: [],
            metadata: []
        },
        onclick: 'view',
        view: {
                label: 'View',
                url: '/admin/ai/call_logs/',
                type: 'drawer',
                component: <CallLogDetails />,
                title: 'Call Log Details',
            },
                    userFilterAdvanced: true,

        userfilter:[
            {
                source: 'created_at',
                label: 'Date',
                type: 'date_range',
                default: {
                    'from': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                    'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                }
            },
            {
                source: 'destination_number',
                label: 'Destination Number',
                type: 'text',
                default: ''
            },
        ],
        metadata: [
            {
                label: 'id',
                source: 'id',
                type: 'primary',
                editable: false,
                visible: false
            },
            {
                label: 'Destination Number',
                source: 'destination_number',
                type: 'text',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Task',
                source: 'ai_task_id',
                type: 'select',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Contact',
                source: 'contact_id',
                type: 'select',
                editable: false,
                default: '',
                placeholder: ''
            },
            {
                label: 'Status',
                source: 'status',
                type: 'enum',
                editable: false,
                default: '',
                values: {
                    'OK': 'OK',
                    'error': 'Error',
                    'pending': 'Pending'
                },
                classnames: {
                    'OK': 'label label-success',
                    'error': 'label label-danger',
                    'pending': 'label label-warning'
                }
            },
            {
                label: 'Created At',
                source: 'created_at',
                type: 'datetime'
            },
            {
                label: 'Updated At',
                source: 'updated_at',
                type: 'datetime'
            }
        ]
    }
    return (
        <Panel title="AI Call Logs">
            <>
                <Tabs tabs={aiTabs} />
                <DataResource
                    data={data}
                    {...props}
                />
            </>
        </Panel>
    );
}

export default AiCallLogs;